




















































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Utilities as utils } from "@/shared/utilities";
import { AppConstants as _app } from "@/shared/app.constants";
import ReportTable from './Components/ReportTable.vue';
import GrantPeriodEditor from './Components/GrantPeriodEditor.vue';
import DateComponent from "@/components/common/Inputs/Date.vue";
import { GrantData, GrantAmendmentData } from "@/entities";
import AmendmentSummary from './Summary.vue';

const namespace: string = "grantAmendment";

@Component({
    components: {
        ReportTable,
        GrantPeriodEditor,
        DateComponent,
        AmendmentSummary
    },
})
export default class GrantSuspension extends Vue {
    @State(namespace) grantAmendment!: GrantAmendmentData;
    @Prop() GrantInfo: any;
    @Prop() GrantData: any;
    @Prop() data: any;
    @Prop() readOnly : any;
    editDialog: boolean = false;
    update = 0;
    @Prop() userType?: number;
    auditor= _app.UserType.Auditor;
    leadPartner = _app.UserType.LeadPartner;

    mounted() {
        this.update + 1;
    }

    finPeriods() {
        if (!this.grantAmendment.grantAmendmentDetailData.suspensionFinReportingPeriod) {
            if (this.GrantData.financialReportingPeriods) {
                this.grantAmendment.grantAmendmentDetailData.suspensionFinReportingPeriod = this.GrantData.financialReportingPeriods;
            } else {
                this.grantAmendment.grantAmendmentDetailData.suspensionFinReportingPeriod = [{}];
            }
        }

        let finList = this.grantAmendment.grantAmendmentDetailData.suspensionFinReportingPeriod;
        if (Object.keys(finList[finList.length - 1]).length == 0) {
            return this.grantAmendment.grantAmendmentDetailData.suspensionFinReportingPeriod.pop();
        }
        else {
            return this.grantAmendment.grantAmendmentDetailData.suspensionFinReportingPeriod;
        }
    }

    techPeriods() {
        if (!this.grantAmendment.grantAmendmentDetailData.suspensionTechReportingPeriod) {
            if (this.GrantData.techReportingPeriods) {
                this.grantAmendment.grantAmendmentDetailData.suspensionTechReportingPeriod = this.GrantData.techReportingPeriods;
            } else {
                this.grantAmendment.grantAmendmentDetailData.suspensionTechReportingPeriod = [{}];
            }
        }

        let techList = this.grantAmendment.grantAmendmentDetailData.suspensionTechReportingPeriod;
        if (Object.keys(techList[techList.length - 1]).length == 0) {
            return this.grantAmendment.grantAmendmentDetailData.suspensionTechReportingPeriod.pop();
        }
        else {
            return this.grantAmendment.grantAmendmentDetailData.suspensionTechReportingPeriod;
        }
    }

    /** edit the period */
    editPeriod() {
        this.editDialog = true;
    }
    closeDialog() {
        this.editDialog = false;
    }
    updatePeriod() {
    }
}
